import { useEffect } from 'react';
import useThrottledCallback from 'beautiful-react-hooks/useThrottledCallback';

/**
 * A custom hook that adds a scroll event listener to the given element and calls the customEventHandler
 * when the user has scrolled to the bottom of the element.
 *
 * @param customEventHandler - An optional function to be called when the user has scrolled to the bottom of the element.
 */
const useHandleScrollBottomEvent = (customEventHandler: (() => void) | undefined) => {
  /**
   * Handles the scroll bottom event.
   *
   * @param e - The event object.
   */
  const handler = useThrottledCallback(
    (e: any) => {
      const target = e.target as Element;
      const { scrollHeight, clientHeight, scrollTop } = target;

      if (scrollHeight - scrollTop <= clientHeight + 10) {
        // console.log('scrolled to bottom');
        if (typeof customEventHandler === 'function') {
          customEventHandler();
        }
      }
    },
    [customEventHandler],
    500
  );
  useEffect(() => {
    const elements = document.getElementsByClassName('dx-scrollable-container');

    Array.from(elements).forEach((element: Element) => {
      element.addEventListener('scroll', handler);
    });

    return () => {
      Array.from(elements).forEach((element: Element) => {
        element.removeEventListener('scroll', handler);
      });
    };
  }, [customEventHandler, handler]);
};

export default useHandleScrollBottomEvent;
